import React, { useState, useEffect } from "react";
import { sendGetRequest, sendPostRequest } from "../../../actions/app-actions";
import { connect } from "react-redux";
import { Container } from "reactstrap";
import { getAdminBusinessId } from "../../../utils/authHelper";
import { MICROSOFT_TEAMS_ID } from "../../../data/integration-app";
import Loader from "../../../components/Loader/Loader";
import ConfirmModal from "../../../components/Modals/Confirm";
import TeamsIcon from "../../../assets/icons/Microsoft_Teams.svg";
import OctoIcon from "../../../assets/icons/octo_icon.svg";
import { notification } from "../../../utils/utility";
import useFeatureRedirect from "../../../hooks/useFeatureRedirect";
import { FEATURE_IDS } from "../../../constants/featureAccess";
import BuilderReturnBar from "../BuilderReturnBar";


const MicrosoftTeamsIntegration = (props) => {

    const [isLoading, setIsLoading] = useState(false);
    const [isConnected, setIsConnected] = useState(false);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    
    useEffect(() => {
      const { sendGetRequest } = props;
      setIsLoading(true);
      sendGetRequest({
        url: `admin/connected-venues/${getAdminBusinessId()}`,
        onSuccess: function (response) {
          const found = response.data.some((integration) => integration.app_id === MICROSOFT_TEAMS_ID);
          setIsConnected(found);
          setIsLoading(false);
        },
        onError: function (error) {
          setIsLoading(false);
        },
      });
    }, []);

      /**
       * 
       */
      const disconnect = (data) => {
        const { sendPostRequest } = props;
        setIsLoading(true);
        sendPostRequest({
          url: `disconnect-microsoft-teams/${getAdminBusinessId()}`,
          data:{
            app_id: MICROSOFT_TEAMS_ID
          },
          onSuccess: function (response) {
            setIsLoading(false);
            if (response.success) {
              notification.success("Microsoft Teams is successfully disconnected!");
              setIsConnected(false);
            }
          },
          onError: function (error) {
            notification.error("We couldn’t disconnect Microsoft Teams right now. Please try again in a few moments.");
            setIsLoading(false);
          },
        });
      }

    /**
     * Connect stripe
    */
    const connectAccount = () => {
      const { sendPostRequest } = props;
      setIsLoading(true);
      sendPostRequest({
        url: `/microsoft-teams-connect`,
        data: {
          business_id: getAdminBusinessId(),
        },
        onSuccess: function (response) {
          if (response.success) {
            window.location.href = response.oauth_url;
          }
          setIsLoading(false);
        },
        onError: function (error) {
          setIsLoading(false);
        },
      });
    }


      return (
        <>
          <BuilderReturnBar />
          {showConfirmModal && (
            <ConfirmModal
              data={{}}
              title="Confirm"
              message="Are you sure, you want to Disconnect from Microsoft Teams ?"
              onConfirm={disconnect}
              onToggle={() => setShowConfirmModal(false)}
            />
          )}
          <Container fluid>
            <Loader isShowLoader={isLoading} />
            {
              !isConnected ? 
              (
                <div className="zoom-feature-int">
                  <div className="row">
                    <div className="col-md-5">
                      <div className="txt">
                        <h3>Features that save your time:</h3>
                        <div className="zoom-info my-3">
                          <ul>
                            <li>
                              Automatically create Microsoft Teams meetings when an event is scheduled.
                            </li>
                            <li>
                              Instantly share unique meeting links upon confirmation.
                            </li>
                          </ul>
                        </div>
                        <h3>Requierments</h3>
                        <div className="zoom-info my-3">
                          <ul>
                            <li>A Microsoft account (Microsoft 365 Business Standard active).</li>
                            <li>
                              Your Teams administrator must approve the Meetocto app in the Microsoft Entra (Azure AD) portal.
                            </li>
                          </ul>
                        </div>
                        <button className="button btn btn-app w-auto" onClick={connectAccount}>
                          Connect Microsoft Teams
                        </button>
                      </div>
                    </div>
                    <div className="col-md-7 mt-md-0 mt-4">
                      <div className="meet-info">
                        <div className="img border-end pe-3">
                          <img src={OctoIcon} alt="Meetocto" />
                        </div>
                        <div className="img zoom-icon ms-4">
                          <img src={TeamsIcon} alt="Google Meet" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="integration-connected-box shadow-sm rounded-4 p-5 bg-white position-relative" style={{ maxWidth: 600, margin: "0 auto" }}>
                    <div className="d-flex flex-column align-items-center justify-content-center mb-4 pb-3 border-bottom text-center">
                      <div className="d-flex align-items-center justify-content-center mb-2" style={{ gap: 32 }}>
                        {/* Our Logo */}
                        <div className="img octo-icon d-flex align-items-center justify-content-center rounded-circle shadow-sm" style={{ background: "#f5f7fa", width: 64, height: 64 }}>
                          <img src={OctoIcon} alt="Meetocto" style={{ width: 40, height: 40 }} />
                        </div>
                        {/* Improved chain with scissors icon */}
                        <div className="d-flex align-items-center justify-content-center" style={{ width: 56, height: 56 }}>
                          <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                              {/* Left chain link */}
                              <rect x="7" y="20" width="12" height="8" rx="4" fill="#B0B7C3" />
                              {/* Right chain link */}
                              <rect x="29" y="20" width="12" height="8" rx="4" fill="#B0B7C3" />
                              {/* Scissors cutting the chain */}
                              <g>
                              <circle cx="24" cy="24" r="3" fill="#F7B801" />
                              <rect x="22.5" y="12" width="3" height="14" rx="1.5" fill="#F7B801" transform="rotate(25 22.5 12)" />
                              <rect x="22.5" y="22" width="3" height="14" rx="1.5" fill="#F7B801" transform="rotate(-25 22.5 22)" />
                              </g>
                          </svg>
                        </div>
                        {/* MS Teams Icon */}
                        <div className="img stripe-icon d-flex align-items-center justify-content-center rounded-circle shadow-sm" style={{ background: "#f5f7fa", width: 64, height: 64 }}>
                            <img src={TeamsIcon} alt="Meetocto" style={{ width: 40, height: 40 }} />
                        </div>
                      </div>
                      <div className="mt-3">
                          <h4 className="mb-1 fw-bold text-primary" style={{ letterSpacing: ".5px" }}>
                          Microsoft Teams Connected
                          </h4>
                          <div className="text-muted small mt-1">
                          Your Stripe account is securely connected to <span className="fw-semibold">Meetocto</span>.<br />
                          You can disconnect Stripe at any time using the button below.
                          </div>
                      </div>
                    </div>
        
                    <div className="mb-4">
                      <ul className="ps-3 mb-3" style={{ listStyleType: "circle" }}>
                        <li className="mb-2">Your Microsoft Teams account is securely connected to <span className="fw-semibold">Meetocto</span>. Schedule and manage meetings effortlessly.</li>
                        <li className="mb-2">Automatic creation of Teams meetings when events are scheduled</li>
                        <li className="mb-2">Instant sharing of meeting links and details with participants</li>
                        <li className="mb-2">Seamless integration with your Teams calendar and workspace</li>
                        <li className="mb-2">Secure connection through Microsoft Entra (Azure AD) authentication</li>
                      </ul>
                      <div className="alert alert-warning py-2 px-3 small mb-0" style={{ fontSize: ".97rem" }}>
                        <i className="bi bi-exclamation-triangle me-2"></i>
                        Disconnecting will stop automatic meeting creation and calendar syncing. Existing meetings remain in your Microsoft Teams account.
                      </div>
                    </div>
                    <div className="d-flex justify-content-center button">
                      <button
                          className="btn btn-app"
                          style={{ fontWeight: 500, fontSize: "1.05rem", borderRadius: "0.5rem" }}
                          onClick={() => setShowConfirmModal(true)}
                      >
                          Disconnect Microsoft Teams
                      </button>
                    </div>
                </div>
              )
            }
          </Container>
        </>
      )

      
}


const ConnectedMicrosoftTeamsIntegration = connect(null, { sendGetRequest, sendPostRequest })(
  MicrosoftTeamsIntegration
);

const MicrosoftTeamsIntegrationGuarded = (props) => {
  useFeatureRedirect(FEATURE_IDS.MICROSOFT_TEAMS, "/integrations");
  return <ConnectedMicrosoftTeamsIntegration {...props} />;
};

export default MicrosoftTeamsIntegrationGuarded;